import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/payment"



export const List = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

export const Details = async (value) => {
    return await axiosInstance(options).get(`${path}/details?_id=${value}`);
}

export const Refund = async (values) => {
  return await axiosInstance(options).post(`${path}/refund`, values);
};

export const ExportExcel = async (values) => {
  return await axiosInstance(options).post(`${path}/export-excel`, values);
};

export const DownloadInvoice = async (id) => {
  return await axiosInstance(options).post(`${path}/download-invoice`, { _id: id });
};

export const Delete = async (values) => {
  const id = values?._id || values;
  return await axiosInstance(options).delete(`${path}/delete?_id=${id}`, { data: values });
};